import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "./cn";
const base = "inline-flex items-center justify-center gap-2 font-display font-medium rounded-pill transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal focus-visible:ring-offset-2 focus-visible:ring-offset-paper dark:focus-visible:ring-offset-ink disabled:opacity-50 disabled:pointer-events-none";
const variants = {
    primary: "bg-signal text-white hover:bg-signal-bright shadow-signal hover:-translate-y-0.5",
    outline: "border border-ink/15 dark:border-paper/20 text-ink dark:text-paper hover:border-signal hover:text-signal dark:hover:text-signal-bright",
    ghost: "text-ink dark:text-paper hover:text-signal dark:hover:text-signal-bright",
};
const sizes = {
    md: "h-11 px-5 text-sm",
    lg: "h-13 px-7 text-base",
};
/** Renders a <button> by default, or an <a> when `as="a"` + href. */
export const Button = forwardRef(function Button({ variant = "primary", size = "md", className, children, ...rest }, ref) {
    return (_jsx("button", { ref: ref, className: cn(base, variants[variant], sizes[size], className), ...rest, children: children }));
});
export const ButtonLink = forwardRef(function ButtonLink({ variant = "primary", size = "md", className, children, ...rest }, ref) {
    return (_jsx("a", { ref: ref, className: cn(base, variants[variant], sizes[size], className), ...rest, children: children }));
});
